import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineRefresh } from 'react-icons/hi';
import { MdOutlineModeEdit } from 'react-icons/md';
import useIsMobile from 'utils/isMobileUtils';
import { Skeleton, Select as MuiSelect } from '@mui/material';

// ✅ Clear
const DetailsTab = ({ productDetails, isLoading, openModalFormWarehouse }) => {

	const onSubmit = () => {
		if (formInfo.userId == '') {
			setAlertMessage({
				user: 'Please select user.'
			});
		} else if (formInfo.date == '') {
			setAlertMessage({
				date: 'Please Select Date.'
			});
		} else if (formInfo.time == '') {
			setAlertMessage({
				time: 'Please Select Time.'
			});
		} else {
			let purchaseId = rows.map((item) => item.purchase_id);
			const data = {
				...formInfo,
				purchase_list_ids: purchaseId
			};
			handleSave(data);
		}
		setTimeout(() => {
			setAlertMessage('');
		}, 1500);
	};

	const isMobile = useIsMobile();
	return (
		<>
			<div className="content mt15">
				<div className="row">
					<div className="col-md-4 col-sm-12 col-12 form-group">
						<div className="card p-2">
							<div className="product-card minHeight230 pad10-25">
								<div className="form-section">
									<div className="product-section-head font18">
										<b>General</b>
									</div>
								</div>

								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<label htmlFor="">Product</label>
										<div style={{ marginLeft: '44px' }}>

											{
												isLoading ? ( 
													<div>
														<Skeleton variant="rounded" width={'150px'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<span className="fw600">{productDetails?.product_name}</span>
												)
											}
											
										</div>
									</div>
								</div>

								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<label htmlFor="">Category</label>
										<div style={{ marginLeft: '35px' }}>

											{
												isLoading ? ( 
													<div>
														<Skeleton variant="rounded" width={'100px'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<span className="fw600">{productDetails?.category?.name}</span>
												)
											}
											
										</div>
									</div>
								</div>
								{productDetails?.storage?.name && (
									<>
										<div className="row">
											<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
												<label htmlFor="">Storage </label>
												<div style={{ marginLeft: '44px' }}>

													{
														isLoading ? ( 
															<div>
																<Skeleton variant="rounded" width={'80px'} height={20} style={{ borderRadius: '32px' }} />
															</div>
														) : (
															<span className="fw600">{productDetails?.storage?.name}</span>
														)
													}
													
												</div>
											</div>
										</div>
									</>
								)}
								{productDetails?.grade?.name && (
									<>
										<div className="row">
											<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
												<label htmlFor="">Grade </label>
												<div style={{ marginLeft: '55px' }}>
													{
														isLoading ? ( 
															<div>
																<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
															</div>
														) : (
															<span className="fw600">{productDetails?.grade?.name}</span>
														)
													}
												</div>
											</div>
										</div>
									</>
								)}
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<label htmlFor="">Status </label>
										<div style={{ marginLeft: '54px' }}>
											{
												isLoading ? ( 
													<div>
														<Skeleton variant="rounded" width={'90px'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													productDetails?.id && (
														productDetails?.status == 1 ? (
															<span className="fw600 text-success">Active</span>
														) : (
															<span className="fw600 text-danger">Inactive</span>
														)
													)
												)
											}
										</div>
									</div>
								</div>
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<label htmlFor="">Client Portal </label>
										<div style={{ marginLeft: '20px' }}>
											{
												isLoading ? ( 
													<div>
														<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													productDetails?.in_portal == 1 ? (
														<span className="fw600 text-success">Active</span>
													) : (
														<span className="fw600 text-danger">Inactive</span>
													)
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 col-12 form-group">
						<div className="card p-2">
							<div className="product-card minHeight230 pad10-25">
								<div className="form-section">
									<div className="product-section-head font18">
										<b>Price</b>
									</div>
								</div>
								<div className="row">
									<div
										className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`}
										style={{
											display: 'flex',
											alignItems: 'center'
										}}
									>
										<label htmlFor="" style={{ minWidth: 120 }}>
											Price
										</label>
										<div className="flex justify-content-end" style={{ flex: 1, textAlign: 'right' }}>
											{
												isLoading ? ( 
													<div style={{ width: '100px' }}>
														<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<span className="fw600">$ {productDetails?.price}</span>
												)
											}
										</div>
									</div>
								</div>
								<div className="row">
									<div
										className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`}
										style={{
											display: 'flex',
											alignItems: 'center'
										}}
									>
										<label htmlFor="" style={{ minWidth: 120 }}>
											Purchase Price
										</label>
										<div className="flex justify-content-end" style={{ flex: 1, textAlign: 'right' }}>
											{
												isLoading ? ( 
													<div style={{ width: '100px' }}>
														<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													<span className="fw600">$ {productDetails?.purchase_price}</span>
												)
											}
										</div>
									</div>
								</div>
								<div className="row">
									<div
										className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`}
										style={{
											display: 'flex',
											alignItems: 'center'
										}}
									>
										<label htmlFor="" style={{ minWidth: 120 }}>
											Markup Percentage
										</label>
										<div className="flex justify-content-end" style={{ flex: 1, textAlign: 'right' }}>
											{
												isLoading ? ( 
													<div style={{ width: '100px' }}>
														<Skeleton variant="rounded" width={'100%'} height={20} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													
													<span className="fw600">
														{productDetails?.markup_percentage && productDetails?.markup_percentage !== '0.00'
															? `${productDetails?.markup_percentage}%`
															: '0%'}
													</span>
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4 col-sm-12 col-12 form-group">
						<div className="card p-2">
							<div className="product-card minHeight230 pad10-25">
								<div className="form-section">
									<div className="product-section-head font18">
										<b>Summary</b>
									</div>
								</div>
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<div style={{ minWidth: '115px' }}>Total Sold</div>
										{
											isLoading ? ( 
												<div className="mb-2">
													<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div>
													<label className="fw600">{Number(productDetails?.quantity_sold).toLocaleString()}</label>
												</div>
											)
										}
									</div>
								</div>
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<div style={{ minWidth: '116px' }}>Backorders</div>
										{
											isLoading ? ( 
												<div className="mb-2">
													<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div>
													<label className="fw600">{Number(productDetails?.quantity_backorders).toLocaleString()}</label>
												</div>
											)
										}
									</div>
								</div>
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<div style={{ minWidth: '116px' }}>Purchase Order </div>
										{
											isLoading ? ( 
												<div className="mb-2">
													<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div>
													<label className="fw600">{Number(productDetails?.quantity_purchased).toLocaleString()}</label>
												</div>
											)
										}
									</div>
								</div>
								<div className="row">
									<div className={`${isMobile ? 'justify-content-between col-12' : 'col-12 font14'}`} style={{ display: 'flex' }}>
										<div style={{ minWidth: '117px' }}>Total Shipped </div>
										{
											isLoading ? ( 
												<div className="mb-2">
													<Skeleton variant="rounded" width={'75px'} height={20} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<div>
													<label className="fw600">{Number(productDetails?.quantity_shipped).toLocaleString()}</label>
												</div>
											)
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div className={`content ${isMobile ? '' : 'mt15'}`}>
				<div className="row">
					<div className="col-12">
						{isMobile ? (
							<div className="row">
								<div className="col-12 form-group">
									<div className="card p-2">
										<div className="product-card minHeight230 pad10-25">
											<div className="form-section">
												<div className="product-section-head font18">
													<b>Inventory</b>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-12 form-group">
									<div className="card p-2">
										<div className="product-card minHeight171 pad10-25">
											<div className="row">
												<div className="col-12">
													{productDetails?.warehouses?.map((warehouse, index) => (
														<div className="" key={warehouse?.id} style={{borderBottom: '1px solid #ddd', paddingBottom: '10px', paddingTop: '10px'}}>
															<div className="row">
																<div className="col-12 fw600">
																	<Link to={`/warehouses/${warehouse?.id}`} className="text-primary">
																		{warehouse?.name}
																	</Link>
																</div>
																<div className="col-12" style={{ display:'flex', gap: 10, alignItems: 'center' }}>
																	<div className="">Free Stock: {warehouse?.free_stocks}</div>
																	<div>|</div>
																	<div className="">Reserved Stock: {warehouse?.reserved_stocks}</div>
																</div>
															</div>
															<div style={{display: 'flex', justifyContent: 'start', marginTop: '10px', gap: 10}}>
																<button className="bulk-action btn-outlined-main " onClick={() => edit()}>
																	<HiOutlineRefresh /> Move Stock
																</button>
																<button className="bulk-action btn-outlined-main ">
																	<MdOutlineModeEdit /> Change Stock
																</button>
															</div>
														</div>
													))}
												</div>
											</div>
									
										</div>
									</div>
								</div>
							</div>
						) : (
							<div className="card">
								<div className="product-card minHeight171 pad15">
									<div className="row ">
										<div className="col-12">
											<div className="form-section">
												<div className="location-section-head font18" style={{ fontSize: '1.5rem' }}>
													<div className="row">
														<div className="col-3">
															<b>Inventory</b>
														</div>
													</div>
												</div>
											</div>
												{
													isLoading ? (
														[...Array(3)].map((e, i) => (
															<Skeleton variant="rounded" width={'100%'} height={60} key={i} style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', paddingTop: '10px', height: '50px', borderRadius: '12px', margin: '15px 0' }} />
														))
													) : (
														productDetails?.product_variants?.length > 0 ? (
															productDetails?.product_variants?.map((variant, index) => (
																<div className="product-warehouse-card" key={variant?.id} style={{ background: '#fff', padding: '15px' }}>
																	<div className="row">
																		<div className="col-md-5 col-12 " style={{ verticalAlign: 'middle' }}>
																			<div className=" ">
																				{productDetails?.product_name} {variant?.color?.name ? variant?.color?.name : 'No color'}
																			</div>
																		</div>
																		<div className="col-md-7 col-sm-12 col-12 ">
																			<div className="row">
																				<div className="col-md-6 col-4 ">Total Stock: {variant?.stock_qty}</div>
																				<div className="col-md-6 col-4 ">Reserved Stock: {variant?.reserved_qty}</div>
																			</div>
																		</div>
																	</div>
																</div>
															))
														) : (
															<div className="product-warehouse-card" style={{ background: '#fff' }}>
																<div className="row">
																	<div className="col-12 text-center" style={{ verticalAlign: 'middle' }}>
																			No Stocks Available
																	</div>
																</div>
															</div>
														)
													)
												}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>


		</>
	);
};

export default DetailsTab;
